/* eslint-disable no-undef */
import { Controller } from 'stimulus';
import { logEvent } from 'utils/analytics';
import Intercom from '@intercom/messenger-js-sdk';
import { maybeConnectBridge } from 'utils/hotwire';

export default class BeaconLink extends Controller {
  static values = { article: String }

  connect() {
    maybeConnectBridge(this.element, "intercom");

    if (!window.Intercom) {
      Intercom({
        app_id: 'v95cgg5k'
      });
    }
  }

  open(e) {
    e.preventDefault();

    logEvent("Get Help - Opened Intercom", { location: "Message", subject: this.element.getAttribute('data-beacon-subject') });

    this.prefillIntercom();

    // Open Intercom messenger with the new conversation view
    window.Intercom('showNewMessage');
  }

  prefillIntercom() {
    const subject = this.element.getAttribute('data-beacon-subject') || '';
    const category = this.element.getAttribute('data-beacon-category') || 'Other';

    // Set custom attributes in Intercom that will be included with the next conversation
    window.Intercom('update', {
      'subject': subject,
      'category': category
    });
  }

  showArticle(e) {
    e.preventDefault();

    logEvent("Get Help - Showing Article", { article: this.articleValue, articleTitle: e.target.textContent });

    // Show a specific article in Intercom
    window.Intercom('showArticle', this.articleValue);
  }
}
